import CookieConsentBanner from './cookieConsentBanner';

function Footer() {
    return (
        <>
            <CookieConsentBanner />
            <footer className="has-text-centered is-size-7 mt-auto mb-0 pb-3 has-background-primary-light has-text-dark">
                <div className="columns mt-3 is-mobile">
                    <div className="column">
                        <div>Copyright @2025 Happy Path Development LLC</div>
                        <div>
                            <a href="https://www.buymeacoffee.com/happypathdev" target="_blank">
                                <img src="https://cdn.buymeacoffee.com/buttons/v2/default-blue.png" alt="Buy Me A Coffee" className="buyMeACoffee" /></a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}


export default Footer;


